import {
  generatePortfolioPagePath,
  PortfolioItemPageParams,
  generateRelatedPortfolio,
} from "./create-pages-utils";
import { ResponsiveImage, LanguageMapItem } from "../../types";

export interface RelatedPortfolioItem {
  category: string[];
  language: string;
  short_description: string;
  slug: string;
  thumbnail: ResponsiveImage;
  url: string;
  title: string;
}
export interface PortfolioItem {
  category: string[];
  color: string;
  created: string;
  description: string;
  gallery_alt: string[];
  hero_color: string;
  language: string;
  accent_color: string;
  section_bg: string;
  short_description: string;
  slug: string;
  title: string;
  url: string;
  gallery: ResponsiveImage[];
  thumbnail: ResponsiveImage;
  related: RelatedPortfolioItem[];
}
export interface PortfolioNode {
  childMdx: {
    id: string;
    body: string;
    frontmatter: PortfolioItem;
  };
  id: string;
  relativeDirectory: string;
  relativePath: string;
  sourceInstanceName: string;
}

export class Portfolio {
  static getNodesByLanguage(language: string, groups: any) {
    const result = Portfolio.splitByLanguage(groups)(language);
    if (result) {
      return result.nodes;
    }
    return null;
  }
  static splitByLanguage(groups: any) {
    return (language: string) => {
      return {
        nodes: groups
          .map((group: any) => {
            const nodes = group.nodes.filter((node: any) => {
              return node.childMdx.frontmatter.language === language;
            });
            return nodes;
          })
          .filter((nodes: any) => {
            return nodes.length;
          })
          .map((node: any) => {
            const relativeUrl = generatePortfolioPagePath(node[0]);
            node[0].childMdx.frontmatter.url = "/" + relativeUrl;
            return node[0];
          }),
        language: language,
      };
    };
  }
  static preparePortfolioItems(groups: any[], fs = null, path = null) {
    const result: PortfolioItemPageParams[] = [];
    const portfolioLanguageGroup = ["pl", "en"].map(
      Portfolio.splitByLanguage(groups)
    );

    groups.forEach((group: any) => {
      const map: LanguageMapItem[] = group.nodes.map((node: any) => {
        return {
          language: node.childMdx.frontmatter.language,
          path: generatePortfolioPagePath(node, true),
        };
      });
      group.nodes.forEach((node: any, index: any) => {
        let componentPath = path
          ? (path as any).resolve(
              "./src/templates/portfolio/portfolio-item.tsx"
            )
          : "";
        const frontmatter = node.childMdx.frontmatter;
        if (typeof frontmatter.template === "string") {
          const templatePath = path
            ? (path as any).resolve(
                "./src/templates/" + frontmatter.template + ".tsx"
              )
            : "";
          if (fs && (fs as any).existsSync(templatePath)) {
            componentPath = templatePath;
          }
        }
        let items = frontmatter.static_related
          ? frontmatter.static_related
          : [];
        if (Array.isArray(items)) {
          frontmatter.related = generateRelatedPortfolio(
            node,
            portfolioLanguageGroup,
            items
          );
        }
        const pagePath = generatePortfolioPagePath(node, true);
        const pageParams = {
          path: pagePath,
          component: componentPath,
          // In your blog post template's graphql query, you can use path
          // as a GraphQL variable to query for data from the markdown file.
          context: { node, language: frontmatter.language, map },
        };
        result.push(pageParams);
      });
    });
    return result;
  }
}
